function requestReviewApproval () {
  return {
    restrict: 'E',
    templateUrl: '/workflow/dialogs/request-review-approval/request-review-approval-dialog.html?$$REVISION$$'
  }
}

export { requestReviewApproval }
